/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface BulkUpdateEquipmentByFilterResponse { 
    matched?: number;
    accepted?: number;
    skippedWithoutFacility?: number;
    skippedByErrorCode?: { [key: string]: number; } | null;
}

